'use client';

import { use$ } from '@legendapp/state/react';
import { ReactiveMotionDiv } from '@/components/ReactiveMotionDiv';
import { useTabState } from '@/components/tabs/TabProvider';

export function TabIndicator() {
    const tabState$ = useTabState();
    const enabled = use$(() => tabState$.indicator.enabled());
    if (!enabled) {
        return null;
    }

    return (
        <ReactiveMotionDiv
            className="tab-indicator tab bg-white rounded-4xl absolute  z-0 text-base-content hidden group-[.has-indicator]:block"
            initial={{
                left: 0,
                top: tabState$.indicator.get()?.top,
                width: tabState$.indicator.get()?.width,
                x: tabState$.indicator.get()?.left,
            }}
            $animate={() => {
                const left = tabState$.indicator.get()?.left;
                const width = tabState$.indicator.get()?.width;
                if (width === undefined || left === undefined) {
                    return {
                        left: 0,
                        display: 'none',
                    };
                }
                return {
                    top: tabState$.indicator.get()?.top,
                    left: 0,
                    width: width,
                    x: left,
                    display: 'block',
                };
            }}
        >
            &nbsp;
        </ReactiveMotionDiv>
    );
}
